let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("2F69B"), load("ffEVr"), load("kHOMt"), load("hhss7"), load("jCgHD")]).then(() => parcelRequire('ig7oA'));